import { useEffect, useState } from "react";
import { Theme } from "react-daisyui";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ThemePicker from "../src/layout/ThemePicker";
import { UserProvider } from "./contexts/UserContext";
import AIReportByEvents from "./pages/AIReportByEvents";
import AIReports from "./pages/AIReports";
import BallTrackerLab from "./pages/BallTrackerLab";
import CodingPage from "./pages/CodingPage";
import FiltersAnalysis from "./pages/FiltersAnalysis";
import ForgotPassword from "./pages/ForgotPassword";
import FrontPage from "./pages/FrontPage";
import GeneralReport from "./pages/GeneralReport";
import Home from "./pages/Home";
import Matches from "./pages/Matches";
import NotFound from "./pages/NotFound";
import ShotsProfileReport from "./pages/ShotsProfileReport";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import StatsPage from "./pages/StatsPage";
import Translation from "./pages/Translation";
import VideoAnalysis from "./pages/VideoAnalysis";

function App() {
  const [currentTheme, setCurrentTheme] = useState(
    localStorage.getItem("theme") ? localStorage.getItem("theme") : "garden"
  );

  // Apply the theme at the <html> level so the page background (incl. the side
  // and bottom margins around the app) matches the selected theme's base-100,
  // and keep the top-level <Theme> wrapper in sync when the theme changes at
  // runtime (daisyUI paints a background on every [data-theme] element, so this
  // wrapper must update or the margins keep the old colour until a reload).
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", currentTheme);
  }, [currentTheme]);

  useEffect(() => {
    const onThemeChange = (e) => {
      const next = e?.detail ?? localStorage.getItem("theme");
      if (next) setCurrentTheme(next);
    };
    window.addEventListener("psts-theme-change", onThemeChange);
    return () => window.removeEventListener("psts-theme-change", onThemeChange);
  }, []);

  return (
    <>
      <UserProvider>
      <Theme dataTheme={currentTheme}>
        {/* <html data-theme={theme}> */}
        <Router>
          <div className="flex flex-col">
            <main className="mx-2 px-2 pb-2">
              {/* <main className="flex flex-col w-full h-[99vh] sm:mx-2 sm:mb-2 overflow-hidden"> */}
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/themepicker" element={<ThemePicker />} />
                <Route path="/sign-in" element={<SignIn />} />
                <Route path="/sign-up" element={<SignUp />} />
                <Route path="/notfond" element={<NotFound />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/translation" element={<Translation />} />
                <Route path="/frontpage" element={<FrontPage />} />
                <Route path="/matches" element={<Matches />} />
                <Route path="/filters-analysis" element={<FiltersAnalysis />} />
                <Route path="/video-analysis" element={<VideoAnalysis />} />
                <Route path="/match-coding" element={<CodingPage />} />
                <Route path="/stats" element={<StatsPage />} />
                <Route path="/report" element={<GeneralReport />} />
                <Route path="/shots-analysis" element={<ShotsProfileReport />} />
                <Route path="/ai-report" element={<AIReports />} />
                <Route path="/ai-report-events" element={<AIReportByEvents />} />
                <Route path="/ball-tracker" element={<BallTrackerLab />} />
                <Route path="/*" element={<NotFound />} />
              </Routes>
            </main>
          </div>
        </Router>
        <ToastContainer />
        {/* </html> */}
      </Theme>
      </UserProvider>
    </>
  );
}

export default App;
